import { render } from "./view-seo.vue?vue&type=template&id=455a4695"
import script from "./view-seo.vue?vue&type=script&lang=js"
export * from "./view-seo.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\domin\\Desktop\\FIles\\front\\jauris\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__